import { buildsServiceApi } from "../../api";
import { ProjectSettingsRequestSchema } from "../../api/project/contracts";
import { ProjectSettingApi } from "../../api/project/types";

export const getProjectSettings = async ({
  projectId,
}: ProjectSettingApi.ProjectSettingsRequest): Promise<ProjectSettingApi.ProjectSettingsResponse> => {
  const validatedData = ProjectSettingsRequestSchema.parse({ projectId });
  return buildsServiceApi
    .get<ProjectSettingApi.ProjectSettingsResponse>(
      `/projects/${validatedData.projectId}/settings?idType=projectId`,
    )
    .then((response) => response.data);
};
